import { browserHistory } from 'react-router';

export default function goToExperienceDetails(
  organization: io.flow.v0.models.OrganizationSummary,
  experience: io.flow.v0.models.Experience,
) {
  return (): void => browserHistory.push(`/${organization.id}/experience/${experience.key}/localization`);
}
